import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { SessionStorageService } from '../../services/session-storage.service';
import { ptUtilityApps } from '../../lib/utility-apps';
import { PostTradeService } from '../post-trade.service';
import { UtilityAppsService } from '../../shared-components/utility-apps/utility-apps.service';

import { TradeReviewDashboardComponent } from '../trade-review/trade-review-dashboard/trade-review-dashboard.component';
import { AccountReviewDashboardComponent } from '../account-review/account-review-dashboard/account-review-dashboard.component';
import { RepReviewDashboardComponent } from '../rep-review/rep-review-dashboard/rep-review-dashboard.component';
import { AmlMonitorDashboardComponent } from '../aml-monitor/aml-monitor-dashboard/aml-monitor-dashboard.component';
import { BackgroundDecorationComponent } from '../../shared-components/background-decoration/background-decoration.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-post-trade',
  templateUrl: './post-trade.component.html',
  styleUrls: ['./post-trade.component.scss'],
  imports: [
    TradeReviewDashboardComponent,
    AccountReviewDashboardComponent,
    RepReviewDashboardComponent,
    AmlMonitorDashboardComponent,
    BackgroundDecorationComponent,
    CommonModule,
    MatIconModule,
  ],
})
export class PostTradeComponent implements OnInit, OnDestroy {
  ptSvc = inject(PostTradeService);
  private ss = inject(SessionStorageService);
  private activatedRoute = inject(ActivatedRoute);
  private route = inject(Router);
  private uas = inject(UtilityAppsService);

  rights = [];
  unsubscribe: Subject<any> = new Subject();
  apps = [
    {
      route: 'trade-review',
      appName: 'Transaction Monitor',
      app: 'TR',
      appRight: 'TradeReview',
      icon: 'beenhere',
    },
    {
      route: 'account-review',
      appName: 'Account Monitor',
      app: 'AR',
      appRight: 'AccountReview',
      icon: 'fact_check',
    },
    {
      route: 'rep-review',
      appName: 'FP Monitor',
      app: 'RR',
      appRight: 'RepReview',
      icon: 'how_to_reg',
    },
  ];
  activeApp;

  ngOnInit(): void {
    this.rights = this.ss.get('rights');
    if (!this.rights.includes('PostTradeReadOnly')) {
      this.apps.push({
        route: 'aml-monitor',
        appName: 'AML Monitor',
        app: 'AML',
        appRight: 'AML',
        icon: 'currency_exchange',
      });
    }
    this.activatedRoute.params
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(params => {
        if (params.view) {
          this.activeApp = params.view;
        } else {
          const defaultApp = this.apps.find(app =>
            this.rights.includes(app.appRight)
          );

          this.activeApp = defaultApp.app;
        }
      });
    this.uas.appsList.set(ptUtilityApps);
  }

  ngOnDestroy() {
    this.uas.appsList.set([]);
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  activateApp(app) {
    this.activeApp = app;
    this.route.navigate([`/post-trade/${app}`]);
  }

  findActiveApp(appName) {
    return this.apps.find(app => app.app === appName);
  }

  nav(location) {
    this.route.navigate([`/${location}`]);
  }
}
